import React, { FC } from 'react';
import cn from 'classnames';
import s from './index.module.less';

interface IOperationButton {
  theme?: string;
  href: string;
  content: React.ReactNode;
  hoverContent?: React.ReactNode;
  disabled?: boolean;
}

const OperationButton: FC<IOperationButton> = ({
  theme = 'primary', href, content, hoverContent, disabled,
}) => (
  <div className={s.wrapper}>
    <a
      className={cn(s.useBtn, [
        `${s[theme]}`,
      ], {
        [s.disabled]: disabled,
      })}
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
        }
      }}
    >
      {content}
    </a>
    <div className={s.hover}>
      {hoverContent}
    </div>
  </div>
);
export default OperationButton;
